var map = {
	"./5_below.svg": 94122,
	"./7-eleven.svg": 33945,
	"./99_cents_only_store.svg": 54187,
	"./99_ranch_market.svg": 70209,
	"./a&w.svg": 38278,
	"./a&w_restaurant.svg": 96741,
	"./abercrombie_&_fitch_co_.svg": 69085,
	"./academy.svg": 82697,
	"./ace_hardware.svg": 32592,
	"./acme.svg": 88037,
	"./adidas.svg": 4561,
	"./advance_auto_parts.svg": 73637,
	"./aeromexico.svg": 58057,
	"./aeropostale_inc_.svg": 39631,
	"./agoda.svg": 74825,
	"./air_canada.svg": 78743,
	"./airbnb.svg": 74655,
	"./alaska_airlines.svg": 95394,
	"./albertsons.svg": 56756,
	"./aldi.svg": 30366,
	"./amazon.svg": 27100,
	"./amazon_fresh.svg": 48299,
	"./american_airlines.svg": 17836,
	"./american_eagle.svg": 1346,
	"./ampm.svg": 6095,
	"./ann_taylor.svg": 87787,
	"./ann_taylor_loft.svg": 57653,
	"./apple.svg": 1176,
	"./applebee_s.svg": 15466,
	"./arby_s.svg": 54843,
	"./arctic_circle.svg": 91723,
	"./ashley_homestore.svg": 64552,
	"./at&t_wireless.svg": 62121,
	"./at_home.svg": 40301,
	"./athleta.svg": 39757,
	"./atwell_suites.svg": 75223,
	"./au_bon_pain.svg": 80516,
	"./auntie_anne_s_soft_pretzels.svg": 67640,
	"./auntie_annes.svg": 10411,
	"./autozone.svg": 47909,
	"./aveda.svg": 90973,
	"./avid.svg": 36469,
	"./bahama_breeze.svg": 17612,
	"./baja_fresh_mexican_grill.svg": 19186,
	"./banana_republic.svg": 89500,
	"./bar_louie-1.svg": 65873,
	"./bar_louie.svg": 8279,
	"./baskin-robbins.svg": 52104,
	"./bass_pro.svg": 64611,
	"./bath_&_body_works.svg": 76269,
	"./bed_bath_&_beyond.svg": 35162,
	"./belk.svg": 75244,
	"./benefit_cosmetics_llc.svg": 65223,
	"./benihana.svg": 14911,
	"./bergdorf_goodman.svg": 15018,
	"./best_buy.svg": 68482,
	"./best_western.svg": 67140,
	"./bevmo.svg": 6232,
	"./big_5.svg": 41023,
	"./big_lots.svg": 9511,
	"./binny_s.svg": 3677,
	"./bj_s_restaurant_&_brewhouse.svg": 12097,
	"./bj_s_wholesale.svg": 15097,
	"./black_bear_diner.svg": 87814,
	"./blain_s_farm_&_fleet.svg": 10018,
	"./blaze_pizza.svg": 47973,
	"./blimpie.svg": 78112,
	"./bloomingdale_s,_inc_.svg": 14362,
	"./blue_apron.svg": 10029,
	"./blue_mercury_inc.svg": 78257,
	"./bob_evans_restaurant.svg": 61149,
	"./bobbi_brown.svg": 87241,
	"./bobbi_brown_cosmetics.svg": 35063,
	"./bojangles_.svg": 95756,
	"./bonduelle.svg": 61430,
	"./bonefish_grill.svg": 44396,
	"./booking_com.svg": 81598,
	"./boscov_s.svg": 20643,
	"./boston_market.svg": 75050,
	"./bp.svg": 31507,
	"./braum_s_ice_cream_&_dairy.svg": 76372,
	"./brooks_brothers.svg": 93355,
	"./bruegger_s_bagels.svg": 12093,
	"./buc-ee_s.svg": 22889,
	"./buca_di_beppo.svg": 41074,
	"./buffalo_wild_wings.svg": 54364,
	"./bumble_and_bumble.svg": 80804,
	"./burger_king.svg": 43002,
	"./burgerfi.svg": 53075,
	"./burlington.svg": 83324,
	"./cabela_s.svg": 49271,
	"./caesars.svg": 25998,
	"./cafe_rio.svg": 17303,
	"./california_pizza_kitchen.svg": 79724,
	"./california_tortilla.svg": 8037,
	"./calvin_klein.svg": 22283,
	"./camping_world.svg": 98206,
	"./candlewood_suites.svg": 50020,
	"./capital_grille.svg": 34200,
	"./captain_d_s_seafood_restaurants.svg": 76476,
	"./carhartt.svg": 83433,
	"./caribou_coffee.svg": 8025,
	"./carl_s_jr_.svg": 71200,
	"./carrabba_s_italian_grill.svg": 63992,
	"./carter_s.svg": 13037,
	"./carvel.svg": 78687,
	"./carvel_ice_cream.svg": 25752,
	"./casey_s_general_store.svg": 57196,
	"./cato.svg": 87693,
	"./cava.svg": 70931,
	"./caviar.svg": 19954,
	"./champs_sports.svg": 44082,
	"./charming_shoppes,_inc_.svg": 81726,
	"./checkers___rally_s.svg": 73296,
	"./cheddar_s_scratch_kitchen.svg": 84327,
	"./chevron.svg": 96517,
	"./chewy_com.svg": 76484,
	"./chick-fil-a.svg": 82280,
	"./chicken_express.svg": 58693,
	"./chico_s.svg": 77304,
	"./chili_s_grill_&_bar.svg": 13278,
	"./chipotle_mexican_grill.svg": 10841,
	"./chuck_e__cheese_s.svg": 62431,
	"./church_s_chicken.svg": 72431,
	"./churchs_hicken.svg": 58888,
	"./chuy_s_mexican_restaurant.svg": 79763,
	"./cici_s_pizza.svg": 84743,
	"./cinnabon.svg": 73293,
	"./circle_k.svg": 35082,
	"./claire_s.svg": 94668,
	"./clarion_inn.svg": 38859,
	"./clinique.svg": 54264,
	"./club_monaco.svg": 34545,
	"./coach.svg": 54985,
	"./cold_stone_creamery.svg": 74917,
	"./cole_haan.svg": 37765,
	"./columbia.svg": 35335,
	"./comfort_inn.svg": 90442,
	"./competitive_set.svg": 49491,
	"./cook_out.svg": 42361,
	"./corner_bakery_cafe.svg": 81884,
	"./corner_store_(various).svg": 93330,
	"./costa_vida.svg": 65706,
	"./costco.svg": 93417,
	"./country_inn___suites.svg": 68904,
	"./cracker_barrel.svg": 72034,
	"./crate_&_barrel.svg": 30098,
	"./crowne_plaza.svg": 98055,
	"./culver_s.svg": 2883,
	"./cvs_pharmacy.svg": 66111,
	"./dairy_queen.svg": 40543,
	"./dave_&_buster_s.svg": 98319,
	"./days_inn.svg": 28071,
	"./deciem.svg": 92121,
	"./del_taco.svg": 20972,
	"./delta_airlines.svg": 33583,
	"./denny_s.svg": 73108,
	"./dick_s_sporting_goods.svg": 48073,
	"./dickey_s_barbecue_pit.svg": 53067,
	"./dillard_s.svg": 64187,
	"./discount_tire.svg": 20276,
	"./dollar_general.svg": 97508,
	"./dollar_tree_stores.svg": 7468,
	"./domino_s_pizza.svg": 68666,
	"./dominos_pizza.svg": 53674,
	"./doordash.svg": 26433,
	"./doubletree.svg": 99779,
	"./drury_hotels.svg": 24521,
	"./dsw.svg": 72881,
	"./duane_reade.svg": 84007,
	"./dunham_s_sports.svg": 41829,
	"./dunkin__donuts.svg": 15636,
	"./dutch_brothers_coffee.svg": 91153,
	"./e_l_f_.svg": 20416,
	"./earth_fare.svg": 27687,
	"./eddie_bauer_inc_.svg": 42507,
	"./einstein_bros_bagels.svg": 69793,
	"./el_pollo_loco.svg": 750,
	"./elf.svg": 3095,
	"./embassy_suites.svg": 38889,
	"./estee_lauder.svg": 89096,
	"./ethan_allen.svg": 2049,
	"./etsy.svg": 91045,
	"./even_hotels.svg": 13247,
	"./expedia.svg": 96352,
	"./express.svg": 58135,
	"./extended_stay_america.svg": 14539,
	"./exxonmobil.svg": 43085,
	"./fairway.svg": 95176,
	"./fairway_market.svg": 56886,
	"./family_dollar.svg": 12458,
	"./farmer_boys.svg": 18848,
	"./fashion_bug.svg": 51455,
	"./fazoli_s.svg": 50482,
	"./ferguson.svg": 19743,
	"./finish_line.svg": 95619,
	"./firehouse_subs.svg": 82407,
	"./first_watch.svg": 14176,
	"./five_guys_burgers_and_fries.svg": 56696,
	"./fleet_farm.svg": 89731,
	"./fleming_s.svg": 12303,
	"./floor_&_decor.svg": 99793,
	"./food_city.svg": 54395,
	"./food_lion.svg": 79704,
	"./food_mart_(various).svg": 92578,
	"./foot_locker.svg": 80577,
	"./forever_21.svg": 66535,
	"./fossil.svg": 43176,
	"./four_seasons.svg": 3731,
	"./francesca_s.svg": 17473,
	"./fred_meyer.svg": 16253,
	"./freddy_s_frozen_custard_and_steakburgers.svg": 635,
	"./fresh_thyme_farmers_market.svg": 94493,
	"./freshdirect.svg": 23507,
	"./freshii.svg": 48387,
	"./friendly_s-1.svg": 33930,
	"./friendly_s.svg": 50520,
	"./frontier_airlines.svg": 89309,
	"./fuddrucker_s.svg": 82882,
	"./function_of_beauty.svg": 71077,
	"./fuzzy_s_taco_shop.svg": 41869,
	"./gamestop.svg": 67224,
	"./gap.svg": 69467,
	"./getgo.svg": 43708,
	"./giant_eagle.svg": 43541,
	"./giant_food.svg": 97103,
	"./glossier.svg": 89202,
	"./golden_corral.svg": 80447,
	"./golf_galaxy.svg": 75309,
	"./google_flights.svg": 61620,
	"./gopuff.svg": 56162,
	"./grainger.svg": 44828,
	"./grubhub_inc_.svg": 3869,
	"./gucci.svg": 44860,
	"./guess.svg": 57048,
	"./guitar_center.svg": 46906,
	"./h&m.svg": 69660,
	"./h-e-b_foods.svg": 98327,
	"./haagen-dazs_shop.svg": 3974,
	"./habit_burger.svg": 42673,
	"./hampton_inn.svg": 91655,
	"./hannaford_supermarket.svg": 31926,
	"./harbor_freight.svg": 73626,
	"./hardee_s.svg": 88758,
	"./harris_teeter.svg": 21450,
	"./hawaiian_airlines.svg": 82516,
	"./hawthorn_suites.svg": 38699,
	"./hello_fresh.svg": 76712,
	"./hershey_s.svg": 1814,
	"./hibbett_sports.svg": 68743,
	"./hilton.svg": 36521,
	"./hilton_garden_inn.svg": 93808,
	"./hobby_lobby.svg": 12814,
	"./holiday_inn.svg": 53937,
	"./holiday_inn_express.svg": 43219,
	"./home_chef.svg": 5797,
	"./homegoods.svg": 61911,
	"./homesense.svg": 53280,
	"./honeybaked_ham.svg": 99289,
	"./hooters.svg": 5217,
	"./hot_topic.svg": 88424,
	"./hotel_indigo.svg": 4197,
	"./hotels_com.svg": 38101,
	"./hotwire.svg": 17819,
	"./howard_johnson.svg": 60909,
	"./huddle_house.svg": 50043,
	"./hungry_howie_s_pizza.svg": 68244,
	"./hy-vee.svg": 77985,
	"./hyatt.svg": 95773,
	"./iga.svg": 87930,
	"./ihop.svg": 25555,
	"./ikea.svg": 13292,
	"./in-n-out_burger.svg": 12435,
	"./ingles_market.svg": 79113,
	"./instacart.svg": 44423,
	"./intercontinental.svg": 78472,
	"./ipsy.svg": 68129,
	"./j__crew.svg": 12495,
	"./j__jill.svg": 31892,
	"./j_c__penney.svg": 93388,
	"./jack_in_the_box.svg": 15926,
	"./jamba_juice.svg": 93530,
	"./jared.svg": 69346,
	"./jason_s_deli.svg": 87044,
	"./jersey_mike_s_subs.svg": 61309,
	"./jetblue.svg": 40341,
	"./jetblue_airways.svg": 67835,
	"./jetbue_airways.svg": 29463,
	"./jewel-osco.svg": 72551,
	"./jiffy_lube.svg": 5198,
	"./jimmy_john_s.svg": 40557,
	"./jo-ann_stores.svg": 8142,
	"./jos__a__bank.svg": 395,
	"./k&g_fashion_superstore.svg": 28524,
	"./kate_spade.svg": 53303,
	"./kay_jewelers.svg": 80257,
	"./kayak.svg": 5977,
	"./kendra_scott.svg": 54848,
	"./kfc.svg": 35625,
	"./kimpton.svg": 6778,
	"./king_soopers.svg": 81450,
	"./kirkland_s.svg": 12392,
	"./kohl_s.svg": 11482,
	"./krispy_kreme.svg": 64210,
	"./kroger.svg": 71042,
	"./krystal.svg": 59130,
	"./kum_&_go.svg": 47417,
	"./kwik_shop.svg": 44306,
	"./kwik_trip.svg": 21926,
	"./l_l__bean_inc_.svg": 26666,
	"./la_madeleine.svg": 18899,
	"./la_quinta.svg": 42350,
	"./lamb_weston.svg": 26664,
	"./lands__end.svg": 58413,
	"./lane_bryant.svg": 93393,
	"./lesaffre.svg": 20977,
	"./levi_strauss_&_co_.svg": 9241,
	"./lidl.svg": 1668,
	"./little_caesars_pizza.svg": 98215,
	"./ll_flooring.svg": 65648,
	"./loaf__n_jug.svg": 22814,
	"./loews.svg": 18309,
	"./logan_s_roadhouse.svg": 87921,
	"./logo_not_found.svg": 7043,
	"./long_john_silver_s_seafood.svg": 63617,
	"./longhorn_steakhouse.svg": 3109,
	"./lord_&_taylor.svg": 8177,
	"./love_s.svg": 24669,
	"./love_s_travel_stops.svg": 8837,
	"./lowe_s_home_improvement.svg": 73993,
	"./lucky_supermarkets.svg": 55404,
	"./lufthansa.svg": 17897,
	"./mac_cosmetics.svg": 33478,
	"./macy_s.svg": 52047,
	"./maggiano_s_little_italy.svg": 76841,
	"./marco_s_pizza.svg": 10589,
	"./market_benchmark.svg": 48293,
	"./marriott.svg": 71168,
	"./marshalls.svg": 12978,
	"./martin_s_super_markets.svg": 15006,
	"./maurices.svg": 26158,
	"./maverik.svg": 85958,
	"./mcalister_s_deli.svg": 76869,
	"./mcdonald_s.svg": 2980,
	"./meijer.svg": 46313,
	"./mellow_mushroom.svg": 33160,
	"./menard.svg": 94468,
	"./menchie_s_frozen_yogurt.svg": 73932,
	"./mgm.svg": 13232,
	"./michael_kors.svg": 84199,
	"./michaels.svg": 38928,
	"./microtel.svg": 14688,
	"./miller_s_ale_house.svg": 20427,
	"./mod_pizza.svg": 30096,
	"./modell_s_sporting_goods.svg": 69041,
	"./moe_s_southwest_grill.svg": 91998,
	"./monro.svg": 98501,
	"./moosejaw.svg": 50389,
	"./morphe.svg": 2540,
	"./motel_6.svg": 19591,
	"./mygofer_llc.svg": 75102,
	"./napa_auto_parts.svg": 1794,
	"./natural_grocers.svg": 32218,
	"./neiman_marcus.svg": 37904,
	"./nekter_juice_bar.svg": 43790,
	"./new_balance.svg": 72585,
	"./new_seasons_market.svg": 44785,
	"./new_york_&_company_inc_.svg": 53298,
	"./newk_s_eatery.svg": 2681,
	"./nike.svg": 35630,
	"./nike_factory_store.svg": 89023,
	"./noodles_&_company.svg": 41247,
	"./nordstrom.svg": 19519,
	"./o-reilly_auto_parts.svg": 25248,
	"./o_charley_s.svg": 86309,
	"./o_reilly_auto_parts.svg": 23473,
	"./office_depot.svg": 76173,
	"./office_max.svg": 23428,
	"./old_navy.svg": 62977,
	"./olive_garden_italian_restaurant.svg": 77986,
	"./ollie_s_bargain_outlet.svg": 64474,
	"./on_the_border.svg": 35168,
	"./orbitz.svg": 97515,
	"./origins_cosmetics.svg": 23751,
	"./origins_natural_resources.svg": 34994,
	"./outback_steakhouse.svg": 7565,
	"./p_f__chang_s_china_bistro.svg": 18537,
	"./pacific_sunwear.svg": 20283,
	"./pancheros_mexican_grill.svg": 55603,
	"./panda_express.svg": 26104,
	"./pandora.svg": 69847,
	"./panera_bread.svg": 11916,
	"./papa_gino_s.svg": 17354,
	"./papa_john_s_pizza.svg": 47610,
	"./papa_murphy_s_take__n__bake_pizza.svg": 29652,
	"./pappadeaux.svg": 10521,
	"./party_city.svg": 50726,
	"./patagonia.svg": 71604,
	"./pdq.svg": 30966,
	"./peapod.svg": 98455,
	"./peet_s_coffee_&_tea.svg": 56297,
	"./pei_wei_asian_diner.svg": 56114,
	"./penn_station_east_coast_subs.svg": 94684,
	"./pep_boys.svg": 67395,
	"./perkins_family_restaurant.svg": 64873,
	"./petco.svg": 66426,
	"./petco_com.svg": 92532,
	"./petland.svg": 51075,
	"./petsmart.svg": 66857,
	"./pieology_pizzeria.svg": 79791,
	"./piercing_pagoda.svg": 33202,
	"./piggly_wiggly.svg": 94155,
	"./pilot_flying_j.svg": 19859,
	"./pinkberry.svg": 342,
	"./pizza_hut.svg": 17689,
	"./planet_smoothie.svg": 94526,
	"./plucker_s_wing_bar.svg": 15759,
	"./pollo_tropical.svg": 99592,
	"./popeyes_louisiana_kitchen.svg": 49314,
	"./postmates.svg": 64214,
	"./potbelly_sandwich_shop.svg": 47267,
	"./pret_a_manger.svg": 25629,
	"./price_rite.svg": 98839,
	"./priceline.svg": 47209,
	"./publix_super_market.svg": 59210,
	"./qdoba_mexican_eats.svg": 29133,
	"./quality_inn.svg": 43199,
	"./quik_stop.svg": 68508,
	"./quiktrip.svg": 65687,
	"./quiznos.svg": 94886,
	"./racetrac.svg": 31211,
	"./rack_room_shoes.svg": 20886,
	"./radisson.svg": 37686,
	"./rainbow_apparel.svg": 66779,
	"./raising_cane_s_chicken_fingers.svg": 53308,
	"./raley_s.svg": 4300,
	"./ralph_lauren.svg": 91130,
	"./ralphs.svg": 61569,
	"./ramada_inn.svg": 79941,
	"./randalls.svg": 73330,
	"./red_bull.svg": 64405,
	"./red_lobster.svg": 60490,
	"./red_robin.svg": 33550,
	"./red_roof_inn.svg": 80900,
	"./reebok.svg": 61872,
	"./rei.svg": 94259,
	"./rita_s.svg": 2263,
	"./rite_aid.svg": 70159,
	"./romano_s_macaroni_grill.svg": 54746,
	"./rooms_to_go.svg": 14681,
	"./ross_dress_for_less.svg": 98174,
	"./round_table_pizza.svg": 84300,
	"./rubio_s.svg": 86501,
	"./ruby_tuesday.svg": 22750,
	"./rusty_taco.svg": 84340,
	"./safeway.svg": 36825,
	"./saks_fifth_avenue.svg": 27189,
	"./saladworks.svg": 26118,
	"./sally_beauty_supply_llc.svg": 66045,
	"./sam_s_club.svg": 56181,
	"./sams_club.svg": 96362,
	"./samsonite_tumi.svg": 31213,
	"./save-a-lot_food_stores.svg": 28476,
	"./sbarro.svg": 65304,
	"./scheels.svg": 45992,
	"./schlotzsky_s.svg": 37323,
	"./sears,_roebuck_and_co_.svg": 6086,
	"./sears_holdings.svg": 25269,
	"./sense360.svg": 39216,
	"./sephora.svg": 59344,
	"./shake_shack.svg": 39384,
	"./shaw_s_supermarket.svg": 13510,
	"./sheetz.svg": 20338,
	"./shell.svg": 9093,
	"./sherwin-williams.svg": 14347,
	"./shipley_do-nuts.svg": 96450,
	"./shipt.svg": 55418,
	"./shoe_carnival.svg": 52660,
	"./shoe_show.svg": 80458,
	"./shop_rite.svg": 4081,
	"./sierra.svg": 26243,
	"./slim_chickens.svg": 1063,
	"./smashburger.svg": 19996,
	"./smith_s_food_&_drug_ctr.svg": 95448,
	"./smoothie_king.svg": 70727,
	"./soma.svg": 85763,
	"./sonic_drive-in.svg": 35329,
	"./sonic_in-drive.svg": 75978,
	"./southwest_airlines.svg": 48231,
	"./speedway.svg": 94192,
	"./spirit_airlines.svg": 36674,
	"./sprint.svg": 17474,
	"./sprouts_farmers_market.svg": 86799,
	"./stage_stores_inc_.svg": 17691,
	"./staples.svg": 56469,
	"./starbucks_coffee.svg": 85880,
	"./staybridge_suites.svg": 37735,
	"./steak__n_shake.svg": 64350,
	"./stein_mart_inc_.svg": 86795,
	"./stop_&_shop_supermarket.svg": 33761,
	"./stripes.svg": 94278,
	"./subway.svg": 85163,
	"./sunoco.svg": 56326,
	"./super_8.svg": 31823,
	"./swarovski.svg": 78198,
	"./sweetfrog.svg": 24730,
	"./sweetgreen.svg": 63063,
	"./t-mobile.svg": 66173,
	"./t_g_i__friday_s.svg": 62932,
	"./taco_bell.svg": 23907,
	"./taco_bueno.svg": 24323,
	"./taco_cabana.svg": 98163,
	"./taco_john_s.svg": 73789,
	"./taco_time.svg": 20444,
	"./talbots.svg": 20543,
	"./target.svg": 99313,
	"./texas_roadhouse.svg": 16015,
	"./the_cheesecake_factory.svg": 23419,
	"./the_children_s_place.svg": 21813,
	"./the_coffee_bean_&_tea_leaf.svg": 50399,
	"./the_counter.svg": 95216,
	"./the_finish_line.svg": 74064,
	"./the_fresh_grocer.svg": 84237,
	"./the_home_depot.svg": 1669,
	"./the_melting_pot.svg": 72166,
	"./the_men_s_wearhouse.svg": 17783,
	"./the_north_face.svg": 45681,
	"./theory.svg": 49999,
	"./tiffany_&_co_.svg": 58616,
	"./tijuana_flats.svg": 3607,
	"./tim_hortons.svg": 50602,
	"./timberland.svg": 83831,
	"./tj_maxx.svg": 1031,
	"./togo_s.svg": 45252,
	"./tommy_hilfiger.svg": 78835,
	"./torchy_s_tacos.svg": 22628,
	"./total_wine_&_more.svg": 24543,
	"./tractor_supply_co_.svg": 3266,
	"./trader_joe_s.svg": 1722,
	"./trivago.svg": 39701,
	"./tropical_smoothie_cafe.svg": 20919,
	"./true_value_co_.svg": 98634,
	"./ubereats.svg": 18758,
	"./ulta_salon.svg": 68968,
	"./under_armour.svg": 12012,
	"./united_airlines.svg": 74458,
	"./urban_outfitters.svg": 95186,
	"./vans.svg": 21608,
	"./vera_bradley.svg": 36025,
	"./verizon_wireless.svg": 89858,
	"./victoria_s_secret.svg": 42996,
	"./village_inn.svg": 89433,
	"./voco.svg": 28175,
	"./vons.svg": 93044,
	"./vrbo.svg": 28151,
	"./waffle_house.svg": 91810,
	"./walgreens.svg": 1593,
	"./walmart.svg": 76240,
	"./warby_parker.svg": 23382,
	"./wawa.svg": 47227,
	"./wayfair.svg": 93638,
	"./wegmans.svg": 76745,
	"./weis_markets.svg": 59135,
	"./wendy_s.svg": 39729,
	"./westjet.svg": 62565,
	"./whataburger.svg": 46222,
	"./which_wich_superior_sandwiches.svg": 72875,
	"./white_castle.svg": 27901,
	"./white_house_black_market.svg": 83289,
	"./whole_foods_market.svg": 66804,
	"./williams-sonoma.svg": 31904,
	"./winco_foods.svg": 69654,
	"./wingstop.svg": 13089,
	"./winn-dixie.svg": 52830,
	"./wyndham.svg": 49933,
	"./wynn.svg": 6585,
	"./yard_house.svg": 62497,
	"./zales.svg": 93858,
	"./zaxby_s.svg": 33577,
	"./zoe_s_kitchen.svg": 90343,
	"./zumiez.svg": 57202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93551;